<template>
	<div class="gc-container">
		<GiftCardHeader />

		<div id="gc-send-notice">
			<div class="gc-wrapper">
				<div class="texts">
					<p class="notice-title">{{ wpOptions.notice_title }}</p>
					<p class="notice-text">{{ wpOptions.notice_text }}</p>
				</div>
			</div>
		</div>

		<div id="sender">
			<div class="gc-wrapper">
				<div class="title cards-title">{{ wpOptions.giver_title }}</div>
				<div class="container">
					<template v-if="$store.state.userLoggedInfo">
						<div class="field">
							<p class="field-name">{{ wpOptions.giver_text }}<span class="required">*</span></p>
							<input type="text" id="giver" ref="giver" class="giver_name" @keyup="clearError($event)" v-model="$store.state.giftCardPurchaseGiverName" />
							<p class="error-message">זהו שדה חובה</p>
						</div>
					</template>

					<template v-else>
						<div class="form-row">
							<div class="form-field">
								<div class="form_tx">
									שם פרטי
									<span class="red">*</span>
								</div>
								<div class="form_input">
									<input
										type="text"
										v-model="$store.state.giftCardForm.first_name"
										v-validate="{ required: true }"
										name="billing_first_name"
										key="billing_first_name"
										data-vv-validate-on="input"
									/>
									<div class="error_tx" v-if="errors.first('billing_first_name')">
										{{ errors.first("billing_first_name") }}
									</div>
								</div>
							</div>
							<div class="form-field">
								<div class="form_tx">
									שם משפחה
									<span class="red">*</span>
								</div>
								<div class="form_input">
									<input
										type="text"
										v-model="$store.state.giftCardForm.last_name"
										v-validate="{ required: true }"
										name="billing_last_name"
										key="billing_last_name"
										data-vv-validate-on="input"
									/>
									<div class="error_tx" v-if="errors.first('billing_last_name')">
										{{ errors.first("billing_last_name") }}
									</div>
								</div>
							</div>
						</div>
						<div class="form-row">
							<div class="form-field">
								<div class="form_tx">
									מייל
									<span class="red">*</span>
								</div>
								<div class="form_input">
									<input
										type="text"
										v-model="$store.state.giftCardForm.email"
										v-validate="'required|email'"
										data-validation="email"
										name="billing_email"
										key="billing_email"
									/>
									<div class="error_tx" v-if="errors.first('billing_email')">
										{{ errors.first("billing_email") }}
									</div>
								</div>
							</div>
							<div class="form-field">
								<div class="form_tx">
									טלפון
									<span class="red">*</span>
								</div>
								<div class="form_input">
									<input
										type="text"
										v-model="$store.state.giftCardForm.phone"
										v-validate="{
                        required: true,
                        regex: /^(?:(?:(\+?972|\(\+?972\)|\+?\(972\))(?:\s|\.|-)?([1-9]\d?))|(0[23489]{1})|(0[57]{1}[0-9]))(?:\s|\.|-)?([^0\D]{1}\d{2}(?:\s|\.|-)?\d{4})$/
                      }"
										data-validation="phone"
										name="billing_phone"
										key="billing_phone"
									/>
									<div class="error_tx" v-if="errors.first('billing_phone')">
										{{ errors.first("billing_phone") }}
									</div>
								</div>
							</div>
						</div>
					</template>
				</div>
			</div>
		</div>

		<div class="gc-wrapper">
			<h2 class="title cards-title">{{ wpOptions.cards_title }}</h2>
		</div>

		<div id="cards">
			<div class="gc-wrapper">
				<div class="card container" v-for="(card, i) in selectedCards" :key="i" :cash_value="card.cash_value">
					<button class="x-button" @click="removeCard(i)" v-if="selectedCards.length>1">
						<img :src="wpData.assets_url + '/svg/close.svg'" alt="">
					</button>
					<div class="card-image">
						<img :src="card.image">
						<p class="card-value">
							<span class="sign">₪</span>
							<span class="num">{{ card.cash_value }}</span>
						</p>
					</div>
					<div class="fields">
						<div class="field">
							<p class="field-name">{{
									wpOptions.receiver_name_field_name
								}}<span class="required">*</span></p>
							<input class="getter_name" type="text" v-model="selectedCards[i].send_details['name']" @keyup="clearError($event)">
							<p class="error-message">זהו שדה חובה</p>
						</div>
						<div class="field radio send_method_container">
							<p class="field-name">{{ wpOptions.send_method_field_name }}</p>
							<input type="radio" v-model="selectedCards[i].send_details['method']" :id="'send_method_their_mail_' + i" value="their_mail" />
							<label :for="'send_method_their_mail_' + i" class="thinner" @click="handleLabelClick($event)">למייל
								של<br />מקבל המתנה</label>
							<input type="radio" v-model="selectedCards[i].send_details['method']" :id="'send_method_sms_' + i" value="sms" />
							<label :for="'send_method_sms_' + i" @click="handleLabelClick($event)">סמס</label>
							<input type="radio" v-model="selectedCards[i].send_details['method']" :id="'send_method_my_mail_' + i" value="my_mail" />
							<label :for="'send_method_my_mail_' + i" class="limit-height" @click="handleLabelClick($event)">רק
								למייל
								שלי</label>
							<p class="send-method-notice" v-if="selectedCards[i].send_details['method'] !== 'my_mail'">
								*עותק להדפסה של
								הגיפטקארד יישלח גם למייל שלך</p>
						</div>
						<div class="field textarea" v-if="selectedCards[i].send_details['method'] === 'their_mail'">
							<p class="field-name">{{ wpOptions.hakdasha_field_name }}</p>
							<textarea class="personal_message" rows="4" noresize v-model="selectedCards[i].send_details['message']"></textarea>
						</div>
						<div class="field" v-if="selectedCards[i].send_details['method'] === 'sms'">
							<p class="field-name">{{ wpOptions.their_phone_field_name }}<span class="required">*</span>
							</p>
							<input class="getter_phone" type="tel" maxlength="10" v-model="selectedCards[i].send_details['phone']" @keypress="isNumber($event)" @keyup="clearError($event)">
							<p class="error-message">זה לא מספר נייד תקין</p>
						</div>
						<div class="field" v-if="selectedCards[i].send_details['method'] == 'their_mail'">
							<p class="field-name">{{ wpOptions.their_mail_field_name }}<span class="required">*</span>
							</p>
							<input class="getter_email" type="text" v-model="selectedCards[i].send_details['email']" @keyup="clearError($event)">
							<p class="error-message">זוהי לא כתובת מייל תקינה</p>
						</div>
					</div>
				</div>
			</div>
		</div>

		<GiftCardNav :step='2' :buttonDisabled='false'></GiftCardNav>

	</div>
</template>

<script>
import Select2 from "@/components/Select2";
import GiftCardHeader from "@/components/GiftCard/GiftCardHeader.vue";
import GiftCardNav from "@/components/GiftCard/GiftCardNav.vue";

export default {
	name: "Send",
	metaInfo: {
		title: wpData.globalOptions.gc_page_purchase.seo_title,
		meta: [{
			name: "description",
			content: wpData.globalOptions.gc_page_purchase.seo_desc
		}]
	},
	data() {
		return {
			wpData: wpData,
			wpOptions: wpData.globalOptions.gc_page_send,
			cards: this.$store.state.giftCardPurchase
		};
	},
	methods: {
		removeCard(i) {
			const el = document.querySelectorAll(".card.container")[i];
			el.classList.add("fade-out");
			setTimeout(() => {
				let cardsIndex = this.cards.findIndex(card => card.cash_value == this.selectedCards[i].cash_value);
				this.cards[cardsIndex]["quantity"]--;
				el.classList.remove("fade-out");
				this.selectedCards.splice(i, 1);
			}, 300);

			// Google Analytics tag
			if (typeof ga !== "undefined") {
				ga.getAll()[0].send({
					hitType: "event",
					eventCategory: "Gift cards",
					eventAction: "Send page - Removed card",
					eventLabel: "Card value: " + el.getAttribute("cash_value"),
					eventValue: 0,
					nonInteraction: false
				});
			}

		},
		handleLabelClick(e) {
			const cardContainer = e.target.parentNode.parentNode.parentNode;
			cardContainer.querySelectorAll("input.getter_email, input.getter_phone").forEach(o => o.parentNode.classList.remove("error"));

		},
		validateField(e) {
			const fieldType = e.getAttribute("class");
			const fieldContainer = e.parentNode;
			const fieldValue = e.value;

			const emailRegex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;

			switch (fieldType) {
				case "giver_name":
					fieldContainer.classList.toggle("error", fieldValue.length < 2);
					break;
				case "getter_name":
					fieldContainer.classList.toggle("error", fieldValue.length < 2);
					break;
				case "getter_email":
					fieldContainer.classList.toggle("error", !emailRegex.test(fieldValue));
					break;
				case "getter_phone":
					fieldContainer.classList.toggle("error", fieldValue.length < 10);
					break;
			}
		},
		validateFields() {
			document.querySelectorAll(".field.error").forEach(o => o.classList.remove("error"));

			if (this.$refs.giver) {
				this.validateField(document.querySelector("input.giver_name"));
			}
			const cardContainers = document.querySelectorAll(".card.container");
			cardContainers.forEach(cardContainer => {
				let fields = [
					cardContainer.querySelector("input.getter_name")
				];

				switch (cardContainer.querySelector(".send_method_container input:checked").value) {
					case "their_mail":
						fields.push(cardContainer.querySelector("input.getter_email"));
						break;
					case "sms":
						fields.push(cardContainer.querySelector("input.getter_phone"));
						break;
					case "my_mail":
						break;
				}

				fields.forEach(field => this.validateField(field));

			});
		},
		clearError(e) {
			e.target.parentNode.classList.remove("error");
		},
		isNumber(e) {
			var charCode = (e.which) ? e.which : e.keyCode;
			if (charCode > 31 && (charCode < 48 || charCode > 57)) {
				e.preventDefault();
				return false;
			}
			return true;
		}
	},
	computed: {
		selectedCards() {
			return this.$store.state.giftCardPurchaseSelectedCards;
		}
	},
	// beforeCreate() {
  //   let newCards = [];
  //   let cards = this.$store.state.giftCardPurchaseSelectedCards;
  //
  //   if (cards.length === 0) { // If no cards selected navigate to first step 'purchase'
  //     this.$router.push({ path: "./purchase" });
  //   }
  //   cards.forEach(card => {
  //     for (var i = 0; i < card.quantity; i++) {
  //       let newCard = { ...card };
  //       newCard.quantity = 1;
  //       newCard.restored = false;
  //       newCard.send_details = {
  //         method: "their_mail",
  //         name: "",
  //         email: "",
  //         phone: "",
  //         message: ""
  //       };
  //       newCards.push(newCard);
  //     }
  //   });
  //
  //   // If there are cards from pervious interaction push their data where possible
  //   if (this.selectedCards.length > 0) {
  //     this.selectedCards.forEach(oldCard => {
  //       i = newCards.findIndex(newCard => {
  //         return (newCard.restored === false) && (newCard.cash_value == oldCard.cash_value);
  //       });
  //       if (i >= 0) {
  //         oldCard.restored = true;
  //         newCards[i] = oldCard;
  //       }
  //     });
  //   }
  //   this.$store.commit("setGiftCardPurchaseSelectedCards", newCards);
	// },
	mounted() {
		// Google analytics tag
		let gaTagData = "";
    this.selectedCards.forEach(card => {
      gaTagData += "[Card value:" + card.cash_value + ", Quantity:" + card.quantity + "]";
    });
		if (typeof ga !== "undefined") {
			ga.getAll()[0].send({
				hitType: "event",
				eventCategory: "Gift cards",
				eventAction: "Selected cards",
				eventLabel: gaTagData,
				eventValue: 0,
				nonInteraction: false
			});
		}
	},
	beforeRouteLeave(to, from, next) {
		if (to.path === "/gift-card/pay") {
			this.validateFields();
			this.$validator.validate().then(success => {
				if (!success) {
					const firstError1 = document.querySelector("input[aria-invalid=\"true\"]");
					window.scrollTo({
						top: firstError1.getBoundingClientRect().top + window.scrollY - 250,
						left: 0,
						behavior: "smooth"
					});
					setTimeout(() => firstError1.focus(), 1000);
					return false;
				} else {
					const formHasErrors = document.querySelectorAll(".field.error").length > 0;
					if (formHasErrors) {
						const firstError2 = document.querySelector(".field.error");
						window.scrollTo({
							top: firstError2.getBoundingClientRect().top + window.scrollY - 160,
							left: 0,
							behavior: "smooth"
						});
						setTimeout(() => firstError2.focus(), 1000);
						return false;
					}
					return true;
				}
			}).then(success => {
				if (success) {
					next(); // Navigate out
				}
			});
		} else {
			next(); // Navigate out
		}
	},
	components: {
		GiftCardHeader,
		GiftCardNav,
		Select2
	}
};
</script>


<style lang="sass" scoped>
@import '../../assets/sass/gift-card-abstracts.sass'

#gc-send-notice .texts
	margin: 2rem 0 3rem 0
	background-color: $dark
	display: flex
	flex-wrap: nowrap
	align-items: center
	padding: 1rem 2rem
	border-radius: 1rem
	position: relative
	max-width: 50%
	+tablet
		display: block
		max-width: 100%
		padding: 1rem

	.notice-title
		color: $orange
		font-size: 1.5rem
		line-height: 1
		font-weight: bold
		margin-left: 3rem
		+tablet
			font-size: 1.25rem
			margin-left: 0
			margin-bottom: 0.25rem

	.notice-text
		color: $white

.required
	color: #c7493a
	display: inline-block
	margin-right: 1px

.container
	background-color: rgba($black, 0.06)
	border-radius: 1rem
	padding: 1.5rem 2rem
	max-width: 58%
	margin: 0
	display: flex
	flex-wrap: nowrap
	align-items: center
	opacity: 1
	transform: scale(1)
	transition: opacity 0ms linear
	+tablet
		max-width: 100%
		width: 100%
		margin-left: auto !important
		padding: 2rem 1rem 1rem 1rem
		display: block

	.title
		+tablet
			margin-bottom: 0.25rem

	&.fade-out
		transition: opacity 300ms ease-in
		opacity: 0

input[type="text"],
input[type="tel"]
	border: none
	outline: none
	border: 1px solid lighten($black, 60%)
	width: 14rem
	border-radius: 3px
	font-size: 1.15rem
	+tablet
		width: 100%

input[type="tel"],
.getter_email
	text-align: left
	direction: ltr

textarea
	resize: none
	border: none
	outline: none
	border: 1px solid lighten($black, 60%)
	border-radius: 3px
	font-size: 1rem
	+tablet
		width: 100%
		margin-bottom: 0.5rem

.title
	font-family: 'simpler'
	letter-spacing: -1px
	font-size: 1.85rem
	font-weight: bold
	line-height: 1
	margin-bottom: 0
	margin-left: 2rem

.field-name
	font-size: 1.15rem
	margin-left: 1rem
	display: inline-block

.cards-title
	margin: 2rem 2rem 2rem 0

.card
	position: relative
	align-items: start
	margin-bottom: 2.5rem

.fields
	display: flex
	flex-wrap: wrap
	width: 100%

.x-button
	width: 2rem
	height: 2rem
	background-color: $white
	border-radius: 100%
	position: absolute
	top: -1rem
	right: -1rem
	border: none
	outline: none
	display: flex
	justify-content: center
	align-items: center
	box-shadow: 0 0 0.5rem 0 rgba($dark, 0.3)

	&:hover
		transform: scale(1.075)

	img
		width: 1rem
		height: 1rem

.field
	width: auto
	margin-bottom: 1.5rem
	+tablet
		width: 100%
		margin-left: 0
		margin-bottom: 0.5rem

	&:nth-child(odd)
		margin-left: 2.5rem
		+tablet
			width: 100%
			margin-left: 0
			margin-bottom: 0.5rem

	&.error
		input[type="text"],
		input[type="tel"]
			border: 1px solid $error
			background-color: lighten($error, 55%)
			color: $error

		.error-message
			opacity: 1

	.title
		+tablet
			margin-top: 0

#sender
	.container
		display: block

		.title
			margin-bottom: 20px

		.form-row
			display: flex
			column-gap: 30px

		.form_tx
			font-size: 1.15rem

		input[aria-invalid="true"]
			border: 1px solid #cc0000 !important
			background-color: #ffe6e6
			color: #cc0000

		.error_tx
			font-size: 0.85rem
			color: #cc0000

		.field
			display: flex
			align-items: center

			.error-message
				margin-right: 1rem

			+tablet
				flex-wrap: wrap
				.error-message
					width: 100%

.send_method_container
	position: relative

	.send-method-notice
		float: none
		font-size: 0.75rem
		opacity: 0.6
		margin: 4rem 0 0 0

.card-image
	position: relative
	+tablet
		text-align: center
		margin-bottom: 1rem

	img
		width: 13rem
		box-shadow: 0 0.5rem 1rem 0 rgba(darken($bg, 50%), 0.3)
		border-radius: 0.5rem
		margin-bottom: 1rem
		margin-left: 3rem
		+tablet
			width: 35vw
			margin-left: auto
		+mobile
			width: 55vw
			margin-left: auto

	.card-value
		position: absolute
		top: 1rem
		left: 4rem
		color: $dark
		+tablet
			left: 35vw
			top: 1.5rem
		+mobile
			top: 1rem
			left: 20vw

		.sign
			font-size: 1rem
			margin-right: 2px

		.num
			font-size: 1.85rem

.field-name
	display: block
	margin-bottom: 0.35rem

.error-message
	font-size: 0.85rem
	color: $error
	margin-top: 0.15rem
	opacity: 0

.radio
	margin: 0
	+tablet
		margin-bottom: 1.5rem

	input
		display: none

	label
		border: 1px solid lighten($black, 60%)
		border-radius: 0.5rem
		background-color: $white
		padding: 1rem
		font-size: 0.85rem
		text-align: center
		float: right
		+tablet
			width: calc(33.33% - 0.34rem)
		+mobile
			padding: 1rem 0.5rem

		&:nth-child(5)
			margin: 0 0.5rem

		&.thinner
			padding: 0.407rem 1rem
			+tablet
				padding: 0.407rem 0.5rem


	input:checked + label
		background: $dark
		color: $white

</style>

<style lang="sass">
#sender
	.select2-container
		max-width: 480px

		a.select2-choice
			border: 1px solid #999999
			font-size: 1.15rem
</style>